import { Col, Dropdown, MenuProps, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import { DownOutlined } from '@ant-design/icons';
import { CustomerInfo } from '@common/models';

import './EstimateInfoCard.scss';

interface EstimateInfoCardProps {
    estimateNumber: string;
    customerInfo: Partial<CustomerInfo>;
    isEstimateDirty: boolean;
    revisionsMenuItems: MenuProps['items'];
}

const oneLineAddress = (...parts: (string | null | undefined)[]): string => {
    return parts
        .map((part) => part?.trim())
        .filter(Boolean)
        .join(', ');
};

export const EstimateInfoCard = ({
    estimateNumber,
    customerInfo,
    isEstimateDirty,
    revisionsMenuItems,
}: EstimateInfoCardProps): JSX.Element => {
    const { t } = useTranslation(undefined, { keyPrefix: 'ADDRESS_INFORMATION.ESTIMATE_CARD' });
    const { customerName, email, address1, city, state, zip } = customerInfo;
    return (
        <div className="EstimateInfoCard">
            <Row gutter={16}>
                <Col>
                    <div className="EstimateInfoCard__label">{t('ESTIMATE_NUMBER')}:</div>
                    <div className="EstimateInfoCard__label">{t('CUSTOMER_NAME')}:</div>
                    <div className="EstimateInfoCard__label">{t('EMAIL')}:</div>
                    <div className="EstimateInfoCard__label">{t('ADDRESS')}:</div>
                </Col>
                <Col>
                    <Dropdown
                        className="EstimateInfoCard__dropdown"
                        trigger={['click']}
                        menu={{ items: revisionsMenuItems }}
                    >
                        <a onClick={(e) => e.preventDefault()}>
                            {estimateNumber} {isEstimateDirty ? ' - Revised, please save' : null}
                            &nbsp; <DownOutlined />
                        </a>
                    </Dropdown>
                    <div>{customerName}</div>
                    <div>{email}</div>
                    <div>{oneLineAddress(address1, city, state, zip)}</div>
                </Col>
            </Row>
        </div>
    );
};
